import { Link } from 'react-router-dom';
import { categories } from '@/mocks/data';

export default function Footer() {
  return (
    <footer className="bg-secondary-900 text-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-4">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-9 h-9 flex items-center justify-center bg-primary-500 text-background-50 rounded-lg text-lg font-bold">
                <i className="ri-emotion-laugh-line"></i>
              </span>
              <span className="font-heading text-xl font-bold text-background-50">搞笑排行榜</span>
            </div>
            <p className="text-secondary-300 text-sm leading-relaxed mb-4">
              搞笑排行榜汇聚全网最火爆的搞笑视频、段子、表情包排行榜，每日更新最好笑的内容TOP10。摸鱼必备、解压神器，让你每天笑出腹肌！
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-secondary-700 text-secondary-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-secondary-700 text-secondary-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-secondary-700 text-secondary-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer" aria-label="抖音">
                <i className="ri-tiktok-line"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-secondary-700 text-secondary-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer" aria-label="B站">
                <i className="ri-bilibili-line"></i>
              </a>
            </div>
          </div>

          <div className="md:col-span-4">
            <h4 className="font-heading text-base font-bold text-background-50 mb-4">热门分类</h4>
            <div className="grid grid-cols-2 gap-2">
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="text-secondary-300 hover:text-primary-400 text-sm transition-colors cursor-pointer whitespace-nowrap"
                >
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>

          <div className="md:col-span-4">
            <h4 className="font-heading text-base font-bold text-background-50 mb-4">关于我们</h4>
            <div className="flex flex-col gap-2">
              <Link to="/about" className="text-secondary-300 hover:text-primary-400 text-sm transition-colors cursor-pointer">
                品牌介绍
              </Link>
              <Link to="/about" className="text-secondary-300 hover:text-primary-400 text-sm transition-colors cursor-pointer">
                联系我们
              </Link>
              <a href="#" className="text-secondary-300 hover:text-primary-400 text-sm transition-colors cursor-pointer">
                投稿合作
              </a>
              <a href="#" className="text-secondary-300 hover:text-primary-400 text-sm transition-colors cursor-pointer">
                广告投放
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-secondary-700 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-secondary-400 text-xs">
            &copy; {new Date().getFullYear()} 搞笑排行榜 gaoxiao-paihangbang.com 版权所有
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-secondary-400 hover:text-primary-400 text-xs transition-colors cursor-pointer">隐私政策</a>
            <a href="#" className="text-secondary-400 hover:text-primary-400 text-xs transition-colors cursor-pointer">用户协议</a>
            <a href="#" className="text-secondary-400 hover:text-primary-400 text-xs transition-colors cursor-pointer">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}